/**
 * 定义请求地址
 * @param local：本地mock
 * @param develop: 本地开发
 * @param feature: 测试环境
 * @param prepub: 预发环境
 * @param production: 线上环境
 **/

import axios from 'axios';
let config = {
  local: 'http://127.0.0.1:3000/api',
  // develop: '120.26.93.6:8084',
  develop: '121.40.239.205:8000',
  feature: '121.40.239.205:8000',
  prepub: 'preapi.tsign.cn',
  production: 'api.tsign.cn'
};

let customConfig = {
  'esign': ['localhost', 'web.dev.cn', 'test.web.tsign.cn', 'preweb.tsign.cn', 'web.tsign.cn'],
  'yonyou': ['yonyoutest.web.tsign.cn', 'yonyouweb.tsign.cn', 'yonyoupreweb.tsign.cn']
};

let oss = 'https://asset.tsign.cn';


let DEVELOP = process.env.DEVELOP || false;
let FEATURE = process.env.FEATURE || false;
let PREPUB = process.env.PREPUB || false;
let PRODUCTION = process.env.PRODUCTION || false;

let apiBaseFn = () => {
  if (DEVELOP) {
    // 本地环境
    return config.develop;
  }
  if (FEATURE) {
    // 测试环境
    return config.feature;
  }
  if (PREPUB) {
    // 预发环境
    return config.prepub;
  }
  if (PRODUCTION) {
    // 线上环境
    return config.production;
  }
};

let apiProtocol = () => {
  if (DEVELOP || FEATURE) {
    return 'http://';
  }
  if (PREPUB || PRODUCTION) {
    // 测试环境
    return 'https://';
  }
};

// let api = () => {
//     if (DEVELOP || FEATURE ||  PRODUCTION || PREPUB) {
//        return apiProtocol() + apiBaseFn() + '/service';
//     } else {
//         return config.local;
//     }
// };

let api = () => {
  if (DEVELOP || FEATURE) {
    return 'http://' + apiBaseFn() + '/service';
  } else if (PREPUB || PRODUCTION) {
    return 'https://' + apiBaseFn() + '/service';
  } else {
    return config.local;
  }
};

let _api = () => {
  if (DEVELOP || FEATURE) {
    return 'http://' + apiBaseFn();
  } else if (PREPUB || PRODUCTION) {
    return 'https://' + apiBaseFn();
  } else {
    return config.local;
  }
}

const customSource = () => {

  const hostname = window.location.hostname;
  //
  // const customizeInfo = JSON.parse(window.sessionStorage.getItem('customizeInfo'));
  // if (customizeInfo && customizeInfo['orgId']) {
  //     return customizeInfo['orgId'];
  // };

  let sourcename = 'esign';
  // ip 地址全部走 ‘esign’
  const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; // ip地址
  if (reg.test(hostname)) {
    return sourcename;
  }
  // 域名
  for (let source in customConfig) {
    if (customConfig[source].indexOf(hostname) > -1) {
      sourcename = source;
      break;
    }
    // for (let i = 0; i < customConfig[source].length; i++){
    //     if (customConfig[source][i] == hostname){
    //         sourcename = source;
    //         break;
    //     }
    // }
  }
  return sourcename;
};

/**
 * oss 静态资源 通用部分地址
 */
const ossAsset = () => {
  /**
   * 线上 + 预发
   */
  if (PREPUB || PRODUCTION) {
    return `${oss}/common`;
  }
  /**
   * 本地 + 测试
   */
  return '/static';
};

const PROTOCOL = apiProtocol();
const HOST = apiBaseFn();
const API = api();
const _API = _api();
const LOCAL = config.local;
const SOURCE = customSource();
const OSSASSET = ossAsset();

export {
  apiBaseFn,
  PROTOCOL,
  HOST,
  API,
  _API,
  LOCAL,
  SOURCE,
  OSSASSET
};



// WEBPACK FOOTER //
// ./src/lib/config.js